<template>
    <div class="c-app">
        <loading :active.sync="bool_fullpageLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_showNotif">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="        width: 55%">
                        <CCol>
                            <CCard>
                                <CCardBody>
                                    <CRow>
                                        <CCol col="10">
                                            <h6 id="traffic" class="card-title mb-0">{{ obj_notif['T'] }}</h6>
                                        </CCol>
                                        <CCol col="2">
                                            <CButton id="btn-close1" class="float-right" @click="closeNotif()">
                                                <CIcon name=cilX></CIcon>
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                    <div class='subHeaderHR'></div>
                                    <CRow>
                                        <!--<CCol col="12">{{ //obj_notif['CBD'] }}</CCol>-->
                                        <CCol col="12" v-html="obj_notif['CBD']"></CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <small class="text-muted float-right">{{ FormatNotifTime(obj_notif['CTS'],obj_notif['CDT']) }}</small>
                                        </CCol>
                                    </CRow>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </div>
                </div>
            </transition>
        </div>

        <SideMenuBar :isSimpleMode.sync="isSimpleMode" />
        <div class='sound-file'>
            <audio id="DepositAudio" src="../../src/assets/sound/deposit.mp3"></audio>
            <audio id="3rdPartyDepositAudio" src="../../src/assets/sound/3rdpartydeposit.mp3"></audio>
        </div>
        <div class="c-wrapper">
            <Header @getSANLength="getSANLength" />
            <div class="c-body">
                <main class="c-main pt-0">
                    <transition name="fade">
                        <router-view :arry_san_length.sync="arry_san_length"></router-view>
                    </transition>
                </main>
            </div>
            <!-- <TheFooter/> -->
        </div>
        <notifications group="msgNotification" position="bottom right" :max="1" :width="350">
            <template slot="body" slot-scope="props">
                <div :class="['custom-template', props.item.type]">
                    <div class="custom-template-content">
                        <div class="custom-template-title">{{props.item.title}}</div>
                        <div class="custom-template-text" v-html="props.item.text"></div>
                    </div>
                    <div class="custom-template-close" @click="props.close">
                        <i class="icon ion-android-close">&times;</i>
                    </div>
                </div>
            </template>
        </notifications>
        <notifications group="msgNotificationTop" position="top left" :max="1" :width="350">
            <template slot="body" slot-scope="props">
                <div :class="['custom-template', props.item.type]">
                    <div class="custom-template-content">
                        <div class="custom-template-title">{{props.item.title}}</div>
                        <div class="custom-template-text" v-html="props.item.text"></div>
                    </div>
                    <div class="custom-template-close" @click="props.close">
                        <i class="icon ion-android-close">&times;</i>
                    </div>
                </div>
            </template>
        </notifications>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import SideMenuBar from "./SideMenu/SideMenuBar";
    import AgentDashboard from "./SideMenu/AgentSetting/AgentDashboard";
    import Header from "./HeaderDropdown/Header";
    import DateRangePicker from "vue2-daterange-picker";
    import Loading from 'vue-loading-overlay';
    //you need to import the CSS manually (in case you want to override it)
    import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
    import Vue from "vue";
    import Vuelidate from "vuelidate";
    import genericHelper from "../modules/GenericHelper.js";
    Vue.use(Vuelidate);
    import moment from "moment";
    import $ from 'jquery'
    import { v4 as uuidv4 } from 'uuid';

    export default {
        mixins: [genericHelper],
        data() {
            return {
                bool_fullpageLoading: false, //Loading Visible
                bool_fullScreen: true, //Full Screen
                arry_san_length: 0,
                showSubMenu: "-1",
                showSubSubMenu: "-1",
                showActiveMenu: "-1",
                isSimpleMode: false,
                bool_showNotif: false,
                obj_notif: [],
                FisrtMenuItem: "",
                AutoUpdateTO: null,
                CheckWindowActiveUpdateTO: null,
                CheckAccessUpdateTO: null,
                tabId: '',                
            };
        },
        components: {
            Loading,
            SideMenuBar,
            Header,
            DateRangePicker,
            AgentDashboard
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion'
            ]),
            ...mapGetters('UserInfo', ['getUserInfo']),
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            clearTimeout(this.CheckWindowActiveUpdateTO);
            clearTimeout(this.CheckAccessUpdateTO);
            next();
        },
        created() {
            //Generate an unique id for each of the tab
            this.tabId = uuidv4();
            sessionStorage.setItem('tabId', this.tabId);            
            localStorage.setItem('tabId', this.tabId);            
            localStorage.setItem('mainTabClosed', null); 
        },
        mounted() {
            this.DepositAudio = document.getElementById('DepositAudio');
            this.ThirdPartyDepositAudio = document.getElementById('3rdPartyDepositAudio');
            this.getPendingTransaction();
            //this.getCSMemberOnline();
            //this.getTotalMember();
            this.checkAuth();
            this.checkWindowActive();

            this.AutoUpdate();
            this.CheckAccessUpdate();
            this.CheckWindowActiveUpdate();                                                

            //To know which tab is active
            window.addEventListener('visibilitychange', this.handleVisibilityChange);
            window.addEventListener('beforeunload', this.handleTabClose);
            window.addEventListener('storage', this.handleStorageChange);

            setTimeout(() => { this.resizeLoadingScreen() }, 500)
            $(document).click(() => { this.resizeLoadingScreen() });
        },
        methods: {
            ...mapActions('DashboardData', [
                'setPendingDeposit',
                'setPendingWithdrawal',
                'setPendingPromotion',
                'setPendingAutoDepositPlus',
                'setMemberOnline',
                'setCSOnline'
            ]),
            closeNotif() {
                this.bool_showNotif = !this.bool_showNotif;
            },
            handleVisibilityChange() {
                // Tab became active
                if (document.visibilityState === 'visible') {
                    localStorage.setItem('tabId', sessionStorage.getItem('tabId'));                                                       
                }               
            },
            handleTabClose() {
                // Check if the current tab is the main tab
                if (localStorage.getItem('tabId') === sessionStorage.getItem('tabId')) {
                    // Remove the main tab ID from localStorage
                    localStorage.removeItem('tabId');
                    // Notify other tabs that main tab is closed
                    localStorage.setItem('mainTabClosed', sessionStorage.getItem('tabId'));
                }
            },
            handleStorageChange(event) {
                // Check if the event is related to the main tab closure
                if (event.key === 'mainTabClosed') {
                    // If this tab is not the main tab, set itself as the new main tab
                    if (localStorage.getItem('tabId') === null) {
                        localStorage.setItem('tabId', sessionStorage.getItem('tabId'));
                    }
                }
            },           
            FormatNotifTime(notifDateTime, currentTime) {

                let startDate = new Date(notifDateTime);
                let endDate = new Date(currentTime);

                let years = endDate.getFullYear() - startDate.getFullYear();
                let months = endDate.getMonth() - startDate.getMonth();
                let days = endDate.getDate() - startDate.getDate();

                if (months < 0) {
                    years--;
                    months += 12;
                }
                if (days < 0) {
                    months--;
                    let lastDayOfMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate();
                    days += lastDayOfMonth;
                }

                let hours = endDate.getHours() - startDate.getHours();
                if (hours < 0) {
                    days--;
                    hours += 24;
                }
                let minutes = endDate.getMinutes() - startDate.getMinutes();
                if (minutes < 0) {
                    hours--;
                    minutes += 60;
                }
                let seconds = endDate.getSeconds() - startDate.getSeconds();
                if (seconds < 0) {
                    minutes--;
                    seconds += 60;
                }

                let t = {};
                if (years > 0) t['DYR'] = years;
                if (months > 0) t['DMTH'] = months;
                if (days > 0) t['DDAY'] = days;
                if (hours > 0) t['DHR'] = hours;
                if (minutes > 0) t['DMT'] = minutes;
                if (seconds > 0) t['DSC'] = seconds;

                var dateKey = Object.keys(t);
                var temp = ""
                for (var i = 0; i < dateKey.length; i++) {
                    temp += t[dateKey[i]] + " ";
                    temp += this.getLanguage['MEM'][dateKey[i]] + " ";
                }
                return temp;
            },
            //Here Set The Dropdown Button Color
            acColor(ac) {
                if (ac == 2) {
                    return "success";
                } else {
                    return "dark";
                }
            },
            getDetail(id) {
                var that = this;
                this.getDataApi(`/api/anotif/ga/${id}`,
                    function (d, s) {
                        if (s) {
                            that.obj_notif = d.D;
                            that.bool_showNotif = true;
                        }
                    });
            },
            checkStatus(ac) {
                if (ac == 2) {
                    return true;
                } else {
                    return false;
                }
            },
            checkpendingColor(owner) {
                if (owner == "") {
                    return "dark";
                } else {
                    return "success";
                }
            },
            getPendingTransaction() {
                var that = this;
                //this.getDataApi(`/api/memtrans/gmpt?p=&n=&f[AGI]=`,
                //    function (d, s) {
                //        if (s) {
                //            var tpd = 0;
                //            var tpp = 0;
                //            var tpw = 0;
                //            for (var i = 0; i < d.D.Items.length; i++) {
                //                tpd += d.D.Items[i].TPD;
                //                tpp += d.D.Items[i].TPP;
                //                tpw += d.D.Items[i].TPW;
                //            }
                //            that.setPendingDeposit(tpd);
                //            that.setPendingPromotion(tpp);
                //            that.setPendingWithdrawal(tpw);
                //            if (0 < tpd || 0 < tpp || 0 < tpw) {
                //                that.DepositAudio.play();
                //            }
                //        }
                //    });

                //Only the main tab will get pending transaction from db
                if (sessionStorage.getItem('tabId') === localStorage.getItem('tabId')) {                    
                    this.getDataApi(`/api/memtrans/gmptv2`,
                        function (d, s) {
                            if (s) {
                                that.setPendingDeposit(d.TPD);                                
                                that.setPendingPromotion(d.TPP);
                                that.setPendingWithdrawal(d.TPW);
                                that.setPendingAutoDepositPlus(d.TUADP);
                                if (0 < d.TPD || 0 < d.TPP || 0 < d.TPW || 0 < d.TUADP) {
                                    that.DepositAudio.play();
                                }

                                if (0 < d.TTPPD) {
                                    that.ThirdPartyDepositAudio.play();
                                }

                                //Store in localstorage for other tabs
                                localStorage.setItem('TPD', d.TPD);
                                localStorage.setItem('TPW', d.TPW);
                                localStorage.setItem('TPP', d.TPP);                                
                                localStorage.setItem('TUADP', d.TUADP);
                                localStorage.setItem('TTPPD', d.TTPPD);                                
                            }
                        });
                }
                else {
                    //Other tabs will get the pending transactions from localstorage stored by main tab                  
                    var TPD = parseInt(localStorage.getItem('TPD'));
                    var TPW = parseInt(localStorage.getItem('TPW'));
                    var TPP = parseInt(localStorage.getItem('TPP'));
                    var TUADP = parseInt(localStorage.getItem('TUADP'));
                    var TTPPD = parseInt(localStorage.getItem('TTPPD'));

                    that.setPendingDeposit(TPD);                    
                    that.setPendingWithdrawal(TPW);
                    that.setPendingPromotion(TPP);
                    that.setPendingAutoDepositPlus(TUADP);

                    if (0 < TPD || 0 < TPP || 0 < TPW || 0 < TUADP) {
                        that.DepositAudio.play();
                    }

                    if (0 < TTPPD) {
                        that.ThirdPartyDepositAudio.play();
                    }
                }                
            },
            // getCSMemberOnline() {
            //     var that = this;
            //     this.getDataApi(`/api/dc/aomo?p=&n=&f[AGI]=`,
            //         function (d, s) {
            //             if (s) {
            //                 //var ao = 0;
            //                 //var mo = 0;
            //                 //for (var i = 0; i < d.D.Items.length; i++) {
            //                 //    if (d.D.Items[i].ICS == 1) {
            //                 //        ao += d.D.Items[i].TO;
            //                 //    } else {
            //                 //        mo += d.D.Items[i].TO;
            //                 //    }
            //                 //}
            //                 that.setCSOnline(d.Item2);
            //                 that.setMemberOnline(d.Item1);
            //             }
            //         });
            // },
            //getTotalMember() {
            //    var that = this;

            //    this.getDataApi(`/api/dc/totalMember`,
            //        function (d, s) {
            //            if (s) {
            //                that.setTotalMember(d);
            //            }
            //        });
            //},
            AutoUpdate() {
                this.nextUpdate()
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            nextUpdate: function () {
                this.getPendingTransaction();
                //this.getCSMemberOnline();
                //this.getTotalMember();
            },
            CheckAccessUpdate() {
                this.nextCheckAccess(); //check auth token every 30 seconds
                var that = this;
                this.CheckAccessUpdateTO = setTimeout(function () {
                    that.CheckAccessUpdate();
                }, 30000);
            },
            nextCheckAccess: function () {
                this.checkAuth();
            },
            CheckWindowActiveUpdate() {
                this.nextCheckWindowActiveUpdate(); //check windows active every 5 sec
                var that = this;
                this.CheckWindowActiveUpdateTO = setTimeout(function () {
                    that.CheckWindowActiveUpdate();
                }, 30000);
            },
            nextCheckWindowActiveUpdate: function () {
                this.checkWindowActive();
            },
            checkAuth() {
                this.getDataApi(`/Auth/CheckAuth`, function (d) {
                    if (!d.S) {
                        localStorage.setItem('isMute', 'False');
                        window.location.href = "/auth/logout?showLogAction=false";
                    }
                });
            },
            checkWindowActive() {
                if (document.hidden && localStorage.getItem('WADT') != null) { //if user is not active
                    var CurrentDateTime = new Date();
                    var LastActiveDateTime = new Date(localStorage.getItem('WADT'));
                    // var autologoutmin = this.getUserInfo.ICS ? 45 : 15;
                    var autologoutmin = 60;

                    if (moment(LastActiveDateTime).add(autologoutmin, 'm').toDate() <= CurrentDateTime) { //15 min inactive
                        localStorage.setItem('isMute', 'False');

                        //Only the last active tab will logout, the inactive tab will not
                        if (sessionStorage.getItem('tabId') === localStorage.getItem('tabId')) {
                            window.location.href = "/auth/logout?showLogAction=true";                            
                        }
                        //else {
                        //    //If the last active tab is closed, let the inactive tabs to take the session                            
                        //    localStorage.setItem('tabId', sessionStorage.getItem('tabId'));                                                      
                        //} 
                    }
                }
                else {
                    //reset windowActiveCount
                    localStorage.setItem('WADT', new Date());                    
                }
            },
            resizeLoadingScreen() {
                const popupExists = document.getElementsByClassName('modal-backdrop').length > 0;

                $(".vld-overlay").css({ 'top': '0px', 'left': '0px' })
                if (!popupExists) {
                    const sidemenuMin = document.getElementsByClassName('c-sidebar-minimized').length > 0;
                    const mgl10 = document.getElementsByClassName('vld-overlay-m10').length > 0;
                    const mgl15 = document.getElementsByClassName('vld-overlay-mgl-15').length > 0;

                    var left = 0;
                    if (mgl10) { left = 10; }
                    else if (mgl15) { left = 15; }

                    if (sidemenuMin) {
                        $(".vld-overlay").css({ 'top': $(".c-header").height() + 'px', 'left': (45 + left) + 'px' })
                    } else {
                        $(".vld-overlay").css({ 'top': $(".c-header").height() + 'px', 'left': ($(".c-sidebar-fixed").width() + left) + 'px' })
                    }
                }
            },
            getSANLength: function (params) {
                this.arry_san_length = params;
            }
        }
    };
</script>





// WEBPACK FOOTER //
// src/components/Dashboard.vue